import React from 'react';

interface PaginationInfo {
  page: number;
  limit: number;
  total: number;
  total_pages: number;
}

interface PaginationProps {
  pagination: PaginationInfo;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: number) => void;
  loading?: boolean;
  className?: string;
}

const Pagination: React.FC<PaginationProps> = ({
  pagination,
  onPageChange,
  onLimitChange,
  loading = false,
  className = ''
}) => {
  // Show pagination if we have data or if we're on a page > 1
  if (pagination.total_pages <= 0 && pagination.page <= 1) {
    return null;
  }

  return (
    <div className={`flex items-center justify-between pt-4 ${className}`}>
      <div className="text-sm text-gray-600">Page {pagination.page} - {pagination.total_pages}</div>
      <div className="flex items-center gap-2 min-w-48">
        <select
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 min-w-24"
          value={pagination.limit}
          onChange={(e) => {
            const newLimit = parseInt(e.target.value, 10);
            onLimitChange(newLimit);
          }}
          disabled={loading}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
        <button
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 min-w-24 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
          disabled={pagination.page === 1 || loading}
          onClick={() => onPageChange(pagination.page - 1)}
        >
          Previous
        </button>
        <button
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 min-w-24 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
          disabled={(pagination.total_pages > 0 && pagination.page === pagination.total_pages) || loading}
          onClick={() => onPageChange(pagination.page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
